{
  "name": "licensing-frontend",
  "private": true,
  "version": "2.4.26",
  "type": "module",
  "scripts": {
    "dev": "yarn g:dev",
    "build": "vue-tsc -b && vite build",
    "build:route:ts": "cd $INIT_CWD && tsx scripts/generate-route-type.ts",
    "build:dev": "cd $INIT_CWD && yarn build:route:ts && vite build --mode=staging",
    "build:prod": "cd $INIT_CWD && yarn build:route:ts && vue-tsc && vite build",
    "tsc": "yarn g:tsc",
    "lint": "yarn g:lint",
    "lint:fix": "yarn g:lint:fix",
    "lint:js": "yarn g:lint:js",
    "lint:js:fix": "yarn g:lint:js:fix",
    "lint:css": "yarn g:lint:css",
    "lint:css:fix": "yarn g:lint:css:fix",
    "test:prod": "yarn g:test:prod",
    "test:dev": "yarn g:test:dev"
  },
  "devDependencies": {
    "@qmulus/frontend-shared": "workspace:^",
    "@types/lodash.merge": "^4"
  },
  "dependencies": {
    "@qmulus/frontend-shared": "workspace:^",
    "@qmulus/ui": "workspace:*",
    "lodash.merge": "^4.6.2",
    "pinia": "^3.0.4"
  }
}
